module.exports = __webpack_public_path__ + "img/fork_carriages.c316b1e8.jpg";